export default __webpack_public_path__ + "static/media/Image-1.4970d99f.jpg";